<script setup>
    import { ref } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { storeToRefs } from 'pinia'
    import { useStageStore } from '@/stores/stage';
    import SaveAsDraftForm from '@/components/forms/SaveAsDraftForm.vue'
    import ConfirmSubmitForm from '@/components/forms/ConfirmSubmitForm.vue'

    const formStorage = useStageStore();
    const { t } = useI18n()
    const { answerEditUrl, showDraftMessage, showDraftForm, showConfirmSubmitForm } = storeToRefs(formStorage)

    const copyDraftLink = ref(t('button.copy-draft-link'))

    function copyToClipboard() {
        if (!answerEditUrl.value) {
            console.error("Link not available")
            return;
        }
        if (!navigator?.clipboard) {
            console.error("Clipboard not available")
            return;
        }

        navigator.clipboard.writeText(answerEditUrl.value)

        copyDraftLink.value = t('button.copy-draft-link-copied');
        setTimeout(() => (copyDraftLink.value = t('button.copy-draft-link')), 2000);
    }

</script>

<template>
    <hr>
    <SaveAsDraftForm v-if="showDraftForm" />

    <ConfirmSubmitForm v-if="showConfirmSubmitForm" />

    <div v-if="!showDraftForm" role="region" aria-live="polite">
        <div v-if="formStorage.isDraft == false" class="thank-you-message">
            <p>{{ t('thank-you-message') }}</p>
        </div>
        <div v-if="showDraftMessage" class="draft-message row mb-4">
            <p>{{ t('saved-as-a-draft-message') }}</p>
            <div class="copy-link">
                <input readonly type="text" class="copy-link-input" :value="answerEditUrl">
                <button type="button" class="copy-link-btn btn btn-secondary ml-1" @click="copyToClipboard">
                    {{ copyDraftLink }}
                </button>
            </div>
        </div>
    </div>

    <div v-if="!showDraftForm && !showConfirmSubmitForm">
        <button v-if="formStorage.getAnswerData.length < formStorage.getAllStages.length" @click="showDraftForm = true" class="btn btn-secondary draft" value="draft" type="button">{{ t('button.save-draft') }}</button>
        <button @click="showConfirmSubmitForm = true" class="btn btn-primary publish" value="publish" type="button">{{ t('button.send-answers') }}</button>
    </div>
</template>